// extracted by mini-css-extract-plugin
export default {"tableHead":"tableHeader_tableHead__Tg4+r"};